import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac6f2f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banned-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "banned-wrapper__owner"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banned-wrapper__des" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "仅空间拥有者可以访问和使用空间"),
    /*#__PURE__*/_createElementVNode("li", null, "空间成员无法访问空间"),
    /*#__PURE__*/_createElementVNode("li", null, "无法分享协作空间")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("恢复使用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("继续访问")
const _hoisted_6 = { key: 1 }

import img from './images/teamBanned.svg'
import Main from '@teams/common/components/error/main.vue'
import { NSpace, NButton } from 'naive-ui'
import { useAcl } from 'vue-simple-acl'
import aclRules from '@teams/common/acl/aclRules'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'banned',
  props: {
    titleTeamOwner: { default: '空间已限制访问' },
    title: { default: '空间已暂停访问' }
  },
  emits: ["continueVisit", "reUse"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'continueVisit'): void
  (e: 'reUse'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { titleTeamOwner: string, title: string }

const acl = useAcl()



const isTeamOwner = computed(() => acl.can(aclRules.is_owner))
const continueVisit = () => {
  emit('continueVisit')
}
const reUse = () => {
  emit('reUse')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isTeamOwner))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Main, {
            img: _unref(img),
            title: props.titleTeamOwner
          }, null, 8, ["img", "title"]),
          _hoisted_3,
          _createVNode(_unref(NSpace), null, {
            default: _withCtx(() => [
              _createVNode(_unref(NButton), { onClick: reUse }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_unref(NButton), {
                onClick: continueVisit,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(Main, {
            img: _unref(img),
            title: props.title
          }, null, 8, ["img", "title"])
        ]))
  ]))
}
}

})